import TransitApi from './base'
import { createFormData } from '@/helpers/TransitHelper'

export default {
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/invoice/list-transit?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async startTransit(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      let result = await Api.get(`/invoice/start-transit?${queryString}`)
      return result
    } catch (error) {
      return error.response
    }
  },
  async caseReady(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/case-ready/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async controlNumber(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/controlNumber/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async denied(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const path = '/invoice/denied/'
      const data = createFormData(params)
      const result = await Api.post(path, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async approve(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/approve/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async payInvoice(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const path = '/invoice/pay-invoice/'
      const data = createFormData(params)
      const result = await Api.post(path, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delivered(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/delivered-invoice/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async deliveredAttachment(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const path = '/invoice/delivered-invoice-attachment/'
      const data = createFormData(params)
      const result = await Api.post(path, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async reinitTransit(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/reinit-transit/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async sendEmailsDenied(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = '/invoice/send-emails-denied/'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },
}
